<section class="product">
  <form [formGroup]="productForm">
    <div class="product-form">
      <!-- Dados principais: 2 colunas (Banco/Produto, Empresa/Período) -->
      <section class="form-section">
        <div class="form-grid form-grid--identity required">
          <app-c-select class="form-field"
                        width="100%"
                        height="44px"
                        appearance="modern"
                        [required]="firstProduct"
                        placeholder="Selecione"
                        label="Banco:"
                        alignItem="flex-start"
                        formControlName="BankId"
                        [readonly]="false"
                        [data]="bankSelectFields"></app-c-select>

          <ng-container *ngIf="firstProduct">
            <app-c-select class="form-field"
                          width="100%"
                          height="44px"
                          appearance="modern"
                          [required]="true"
                          placeholder="Selecione"
                          label="Produto:"
                          alignItem="flex-start"
                          formControlName="ProductId"
                          [readonly]="false"
                          [data]="productSelectFields"
                          valueDefault="produto"></app-c-select>
          </ng-container>

          <app-c-select class="form-field"
                        width="100%"
                        height="44px"
                        appearance="modern"
                        [required]="firstProduct"
                        placeholder="Selecione"
                        label="Empresa:"
                        alignItem="flex-start"
                        formControlName="CompanyId"
                        [readonly]="false"
                        [data]="companySelectFields"></app-c-select>

          <app-c-input class="form-field"
                       width="100%"
                       height="44px"
                       appearance="modern"
                       [required]="firstProduct"
                       placeholder="mm/aaaa"
                       label="Período:"
                       inputMask="00/0000"
                       alignItem="flex-start"
                       formControlName="Period"
                       [isProduct]="true"
                       [readonly]="false"></app-c-input>
        </div>
      </section>

      <!-- Tipo de comissão: rádios simples -->
      <section class="form-section form-section--type">
        <p class="form-section__label" id="commission-type-label">Tipo de Comissão:</p>

        <div class="commission-type-toggle" role="radiogroup" aria-labelledby="commission-type-label">
          <label class="commission-type-toggle__option"
                 [ngClass]="{ 'commission-type-toggle__option--active': isCommissionType(1) }">
            <input class="commission-type-toggle__input"
                   type="radio"
                   formControlName="CommissionType"
                   name="CommissionType"
                   [value]="1" />
            <span class="commission-type-toggle__control" aria-hidden="true"></span>
            <span class="commission-type-toggle__text">Fixa</span>
          </label>
          <label class="commission-type-toggle__option"
                 [ngClass]="{ 'commission-type-toggle__option--active': isCommissionType(2) }">
            <input class="commission-type-toggle__input"
                   type="radio"
                   formControlName="CommissionType"
                   name="CommissionType"
                   [value]="2" />
            <span class="commission-type-toggle__control" aria-hidden="true"></span>
            <span class="commission-type-toggle__text">Variável</span>
          </label>
        </div>
      </section>

      <!-- Valores da comissão -->
      <section class="form-section">
        <ng-container *ngIf="isCommissionType(1)" formArrayName="Productions">
          <ng-container *ngFor="let productionGroup of formGroupsProductions.controls; let indexTransfer = index">
            <div class="production-row fade-in" [formGroupName]="indexTransfer">
              <app-c-input class="form-field production-row__field"
                           width="100%"
                           height="44px"
                           appearance="modern"
                           label="Valor fixo Credimorar (R$):"
                           alignItem="flex-start"
                           formControlName="InvoiceValue"
                           inputMask="separator.2"
                           [currencyMask]="true"
                           [isProduct]="true"
                           [readonly]="false"></app-c-input>
              <app-c-input class="form-field production-row__field"
                           width="100%"
                           height="44px"
                           appearance="modern"
                           label="Valor fixo beneficiários (R$):"
                           alignItem="flex-start"
                           formControlName="TransferValue"
                           inputMask="separator.2"
                           [currencyMask]="true"
                           [isProduct]="true"
                           [readonly]="false"></app-c-input>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="isCommissionType(2)" formArrayName="Productions">
          <ng-container *ngFor="let productionGroup of formGroupsProductions.controls; let indexProduction = index">
            <div class="production-row production-row--variable fade-in">
              <div class="production-row__fields" [formGroupName]="indexProduction">
                <app-c-input *ngFor="let production of productionFields; let indexField = index"
                             class="form-field production-row__field"
                             [class.production-row__field--percent]="indexField === productionFields.length - 1"
                             width="100%"
                             height="44px"
                             appearance="modern"
                             alignItem="flex-start"
                             inputType="text"
                             inputMask="separator.2"
                             [currencyMask]="production.currencyMask"
                             separatorLimit="100000000000"
                             [label]="production.label"
                             [index]="indexProduction"
                             [formControlName]="production.controlName"
                             [isProduct]="true"
                             [readonly]="false"></app-c-input>
              </div>

              <div class="production-row__actions">
                <button *ngIf="indexProduction === formGroupsProductions.controls.length - 1"
                        type="button"
                        class="production-row__action-btn"
                        aria-label="Adicionar faixa"
                        (click)="insertProduction()">
                  <app-svg-icon src="../../../../assets/icons/add-icon.svg"
                                color="lightGray"
                                width="14px"
                                height="14px"></app-svg-icon>
                </button>

                <button *ngIf="formGroupsProductions.controls.length > 1"
                        type="button"
                        class="production-row__action-btn"
                        aria-label="Remover faixa"
                        (click)="removeProduction(indexProduction)">
                  <app-svg-icon src="../../../../assets/icons/remove-icon.svg"
                                color="dangerRed"
                                width="16px"
                                height="16px"></app-svg-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </section>

      <!-- Limite -->
      <section class="form-section">
        <div class="form-grid form-grid--single">
          <app-c-input class="form-field"
                       width="100%"
                       height="44px"
                       appearance="modern"
                       label="Valor máx. de comissão por contrato (R$)"
                       alignItem="flex-start"
                       formControlName="MaxCommissionPerContract"
                       inputMask="separator.2"
                       [currencyMask]="true"
                       [isProduct]="true"
                       [readonly]="false"></app-c-input>
        </div>
      </section>
    </div>
  </form>
</section>
